import { create } from 'zustand';
import { z } from 'zod';

import { APIEndPoints, Request } from '../apis';
import type { TMerchant } from '../components/types';

type AccountListStoreState = {
  merchants: ReadonlyArray<TMerchant>;
  shouldSetSuccess: boolean;
  shouldSetError: boolean;
  isLoading: boolean;
  setMerchants: () => void;
  handleOnSuccess: (merchants: ReadonlyArray<TMerchant>) => void;
  handleOnError: () => void;
  clearState: () => void;
};

const STARTING_STATE = {
  merchants: [],
  shouldSetSuccess: false,
  shouldSetError: false,
  isLoading: true
} as const;

export const useAccountListStore = create<AccountListStoreState>((set) => ({
  ...STARTING_STATE,
  setMerchants: async () => {
    const merchants = await getMerchantsRequest();
    set({
      merchants,
      isLoading: false
    });
  },
  handleOnSuccess: (merchants: ReadonlyArray<TMerchant>) => {
    set({
      shouldSetSuccess: true,
      shouldSetError: false,
      isLoading: false,
      merchants
    });
  },
  handleOnError: () => {
    set({
      shouldSetSuccess: false,
      shouldSetError: true,
      isLoading: false,
      merchants: []
    });
  },
  clearState: () => {
    set({ ...STARTING_STATE });
  }
}));

export const clearAccountListStore = () => {
  useAccountListStore.setState({ ...STARTING_STATE });
};

const getMerchantsRequest = (): Promise<ReadonlyArray<TMerchant>> => {
  return Request.get<ReadonlyArray<TMerchant>>({
    path: `${APIEndPoints.merchants}?access_token`,
    schema: z.any()
  });
};
